// extracted by mini-css-extract-plugin
export default {"img":"StoryTableRow_img__BxWQA"};